const state = {
  list: [],
  selectedDomain: null,
};

const getters = {
  customerDomainList: (state) => state.list,
  selectedCustomerDomain: (state) => state.selectedDomain,
};

const actions = {
  async fetchCustomerDomainListEntry(
    { commit },
    { id, policyId, action, domainId }
  ) {
    const response = await this._vm.$http.get(
      `/restapi/policies/${policyId}/domains/${action}/${domainId}?user_id=${id}`
    );

    commit("setSelectedListEntry", response.data);
  },

  async fetchCustomerDomainList({ commit }, { id, policyId = null }) {
    const response = await this._vm.$http.get(
      policyId
        ? `/restapi/policies/${policyId}/domains/all?user_id=${id}`
        : `/restapi/users/${id}/all`
    );

    commit("setCustomerList", response.data.data);
  },

  async createCustomerDomainListEntry(
    { commit },
    { id, policyId, body, action }
  ) {
    const response = await this._vm.$http.post(
      `/restapi/policies/${policyId}/domains/${action}?user_id=${id}`,
      body
    );

    commit("addListEntry", response.data);
    return response.data;
  },
  // eslint-disable-next-line no-unused-vars
  async addBlockAllowed({ _ }, { policyId, file, action }) {
    let csv = new FormData();

    csv.append("csv", file);

    await this._vm.$http.post(
      `/restapi/policies/${policyId}/domains/import/${action}?overwrite=true`,
      csv,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  // eslint-disable-next-line no-unused-vars
  async addBlockAllowedUser({ _ }, { policyId, file, action, id }) {
    let csv = new FormData();

    csv.append("csv", file);

    await this._vm.$http.post(
      `/restapi/policies/${policyId}/domains/import/${action}?overwrite=true&user_id=${id}`,
      csv,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  async updateCustomerDomainListEntry(
    { commit },
    { id, policyId = "default", domainId, action, body }
  ) {
    const response = await this._vm.$http.put(
      `/restapi/policies/${policyId}/domains/${action}/${domainId}?user_id=${id}`,
      body
    );

    const index = state.list.findIndex(
      (entry) => entry.id === response.data.id
    );

    if (index === -1) {
      commit("addListEntry", response.data);
    } else {
      commit("updateListEntry", {
        idx: index,
        locationAddress: response.data,
      });
    }

    commit("setSelectedListEntry", response.data);
  },

  async deleteCustomerDomainListEntrys({ commit }, { userId, domains }) {
    const req = {};

    for (const domain of domains) {
      req[domain.id] = {
        method: "delete",
        path: `/policies/${
          domain.policyname === "Default" ? "default" : domain.policyid
        }/domains/${domain.object}/${domain.id}?user_id=${userId}`,
      };
    }

    const res = await this._vm.$http.post("/restapi/batch", req);
    const ids = Object.keys(res.data).map((item) => +item);
    commit("deleteListEntry", ids);
  },
};

const mutations = {
  setCustomerList: (state, data) => (state.list = data),
  setSelectedListEntry: (state, data) => (state.selectedDomain = data),
  addDomainListEntry: (state) => state.list,
  addListEntry: (state, data) => state.list.push(data),
  updateListEntry: (state, data) =>
    (state.list[`${data.idx}`] = data.locationAddress),
  deleteListEntry(state, domains) {
    state.list = state.list.filter((domain) => !domains.includes(domain.id));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
